import React, { useState, useEffect } from "react";
import { Skeleton } from "antd";
import { getAllRegistries } from "../../../utils/api/getAllRegistries";
import { useAuthContext } from "../../../context/AuthContext";

const Registries = ({ selectedRegistry, onCheckRegistry , onSelectKey=(value)=>{ } }) => {
  const [registries, setRegistries] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setAuthUser } = useAuthContext();

  useEffect(() => {
    const fetchRegistries = async () => {
      setLoading(true);
      try {
        const registriesData = await getAllRegistries(setAuthUser);
        setRegistries(registriesData);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchRegistries();
  }, [setAuthUser]);

  const handleRegistryChange = (e) => {
    const selectedValue = e.target.value;
    const selected = registries.find(
      (registrie) => registrie.registryName === selectedValue
    );
    onCheckRegistry(selected ? selected.registryName : "");
    onSelectKey(selected ? selected._id : "");
  };

  return (
    <div className="flex flex-col text-xs gap-y-4 w-2/3">
      {loading ? (
        <Skeleton.Button block={true} active={true} />
      ) : (
        <select
          value={selectedRegistry}
          onChange={handleRegistryChange}
          className="p-2 border rounded-md  focus:outline-none focus:ring-0"
        >
          <option value="" disabled>
            Select the Registry
          </option>
          {registries.map((registry) => (
            <option key={registry.registryName} value={registry.registryName}>
              {registry.registryName}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default Registries;
